import _ from 'lodash';
import {combineReducers} from 'redux';
import {
  SET_REPORT_DATE_RANGE_FILTER,
  SET_REPORT_DEVICES_FILTER,
  SET_REPORT_TAGS_FILTER,
  SET_REPORT_QUESTION_FILTER,
  RESET_REPORT_WIDGETS_LOADING_STATE,
  SET_REPORT_WIDGET_LOADING_STATE,
} from './actions';


function reports(state = [], action) {
  switch (action.type) {
    case SET_REPORT_DATE_RANGE_FILTER:
      if (_.find(state, {id: action.reportId})) {
        return state.map((report) => {
          if (report.id === action.reportId) {
            return Object.assign({}, report, {
              dateRange: action.dateRange,
            });
          } else {
            return report;
          }
        });
      } else {
        return [
          ...state,
          {
            id: action.reportId,
            dateRange: action.dateRange,
          }
        ];
      }
    case SET_REPORT_DEVICES_FILTER:
      if (_.find(state, {id: action.reportId})) {
        return state.map((report) => {
          if (report.id === action.reportId) {
            return Object.assign({}, report, {
              deviceIds: action.deviceIds,
            });
          } else {
            return report;
          }
        });
      } else {
        return [
          ...state,
          {
            id: action.reportId,
            deviceIds: action.deviceIds,
          }
        ];
      }
    case SET_REPORT_TAGS_FILTER:
      if (_.find(state, {id: action.reportId})) {
        return state.map((report) => {
          if (report.id === action.reportId) {
            return Object.assign({}, report, {
              deviceIdsByTags: action.deviceIdsByTags,
            });
          } else {
            return report;
          }
        });
      } else {
        return [
          ...state,
          {
            id: action.reportId,
            deviceIdsByTags: action.deviceIdsByTags,
          }
        ];
      }
    case SET_REPORT_QUESTION_FILTER:
      if (_.find(state, {id: action.reportId})) {
        return state.map((report) => {
          if (report.id === action.reportId) {
            const questionFilters = report.questionFilters || [];
            if (_.find(questionFilters, {questionId: action.questionId})) {
              return Object.assign({}, report, {
                questionFilters: questionFilters.map((filter) => {
                  if (filter.questionId === action.questionId) {
                    return Object.assign({}, filter, {
                      options: action.options,
                    });
                  } else {
                    return filter;
                  }
                }),
              });
            } else {
              return Object.assign({}, report, {
                questionFilters: [
                  ...questionFilters,
                  {
                    questionId: action.questionId,
                    options: action.options,
                  }
                ]
              });
            }
          } else {
            return report;
          }
        });
      } else {
        return [
          ...state,
          {
            id: action.reportId,
            questionFilters: [
              {
                questionId: action.questionId,
                options: action.options,
              }
            ],
          }
        ];
      }
    case RESET_REPORT_WIDGETS_LOADING_STATE:
      if (_.find(state, {id: action.reportId})) {
        return state.map((report) => {
          if (report.id === action.reportId) {
            return Object.assign({}, report, {
              widgets: action.widgetIds.map(id => {
                return {
                  id,
                  loaded: false,
                };
              }),
            });
          } else {
            return report;
          }
        });
      } else {
        return [
          ...state,
          {
            id: action.reportId,
            widgets: action.widgetIds.map(id => {
              return {
                id,
                loaded: false,
              };
            }),
          }
        ];
      }
    case SET_REPORT_WIDGET_LOADING_STATE:
      if (_.find(state, {id: action.reportId})) {
        return state.map((report) => {
          if (report.id === action.reportId) {
            const reportWidgets = report.widgets || [];
            return Object.assign({}, report, {
              widgets: reportWidgets.map((widget) => {
                if (widget.id === action.widgetId) {
                  return Object.assign({}, widget, {
                    loaded: action.loaded,
                  });
                } else {
                  return widget;
                }
              }),
            });
          } else {
            return report;
          }
        });
      } else {
        return [
          ...state,
          {
            id: action.reportId,
            widgets: [{id: action.widgetId, loaded: action.loaded}],
          }
        ];
      }
    default: 
      return state;
  }
}

export default combineReducers({
  reports,
});



// WEBPACK FOOTER //
// ./src/services/redux/reducer.js